import React from "react";
import { useSelector } from "react-redux";
import { userRequest } from "../request";
import { toast } from "react-hot-toast";
const ProjectCard = ({ project, onUpdate }) => {
  const token = useSelector((state) => state.user.user.token);
  const updateStatus = async (status) => {
    try {
      const response = await userRequest(token).put(
        `/project/${project._id}/status`,
        { status }
      );
      onUpdate(response.data);
      toast.success("Status updated!");
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  return (
    <div className="projectcard m-2">
      <div className="lg:hidden projectcardmobile relative shadow-lg border p-4 flex flex-col gap-3 rounded-xl text-gray-500">
        <div>
          <p className=" font-bold text-black">{project.projectName}</p>
          <p>
            {project.startDate} to {project.endDate}
          </p>
        </div>
        <div>
          <div className="flex items-center gap-2">
            <p>reason :</p>
            <p className=" text-black">{project.reason}</p>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2">
              <p>Type</p> <p className="text-black">{project.type}</p>
            </div>
            <div className="flex items-center gap-2">
              <div className=" rounded-full p-[3px] bg-gray-400" />
              <p>Category</p>
              <p className="text-black">{project.category}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2">
              <p>Div</p>
              <p className="text-black">{project.division}</p>
            </div>
            <div className="flex items-center gap-2">
              <div className=" rounded-full p-[3px] bg-gray-400" />

              <p>Dept</p>
              <p className="text-black">{project.department}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <p>Location</p>
            <p className="text-black">{project.location}</p>
          </div>
          <div className="flex items-center gap-2">
            <p>priority</p>
            <p className="text-black">{project.priority}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button className=" bg-primary text-white rounded-3xl p-2 px-6"             onClick={() => updateStatus("Running")}
>
            Start
          </button>
          <button className=" border-primary border-2 text-primary rounded-3xl p-2 px-6"             onClick={() => updateStatus("Closed")}
>
            close
          </button>
          <button className=" border-primary border-2 text-primary rounded-3xl p-2 px-6"             onClick={() => updateStatus("Cancelled")}
>
            Cancel
          </button>
        </div>
        <div className=" absolute top-0 right-0 m-2 font-bold text-sky-900">
          {project.status}
        </div>
      </div>
      <div className="projectcarddesktop hidden lg:block lg:grid grid-cols-12 items-center gap-6 p-4 text-gray-500">
        <div className="col-span-2 ">
          <p className=" font-bold py-2 text-black">{project.projectName}</p>
          <p>
            {project.startDate} to {project.endDate}
          </p>
        </div>
        <div className="col-span-1">{project.reason}</div>
        <div className="col-span-1">{project.type}</div>
        <div className="col-span-1">{project.division}</div>
        <div className="col-span-1">Quality {project.category}</div>
        <div className="col-span-1">{project.priority}</div>
        <div className="col-span-1">{project.department}</div>
        <div className="col-span-1">{project.location}</div>

        <div className="col-span-1 font-bold text-sky-900">
          {project.status}
        </div>
        <div className="col-span-2 flex items-center gap-2">
          <button
            className=" bg-primary text-white rounded-3xl p-1 px-2"
            onClick={() => updateStatus("Running")}
          >
            Start
          </button>
          <button
            className=" border-primary border-2 text-primary rounded-3xl p-1 px-2"
            onClick={() => updateStatus("Closed")}
          >
            close
          </button>
          <button
            className=" border-primary border-2 text-primary rounded-3xl p-1 px-2"
            onClick={() => updateStatus("Cancelled")}
          >
            Cancel
          </button>
        </div>
      </div>
      <hr />
    </div>
  );
};

export default ProjectCard;
